import {useState, useEffect} from 'react'
import {
  useLazyGetHowToVideosQuery,
  useLazyGetHowToVideosAdminQuery,
  useLazyGetHowToVideosByFeatureQuery,
} from '../../services/cellcast'
import {HowToVideo} from '../../services/cellcast.type'
import {useDebounce} from '../../_metronic/helpers'

// Fallback data for when API is not available
const fallbackVideos = [
  {
    _id: '1',
    title: 'What Can You Do with Cellcast?',
    description:
      'Discover how to navigate and unlock the power of Cellcast with this 5-minute tutorial video.',
    subTitle: "Explore what's possible with Cellcast",
    subDescription:
      'Unlock the full potential of SMS and MMS marketing with Cellcast. Learn how businesses use the platform to connect, engage, and grow with ease.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    category: 'getting-started',
    isActive: true,
  },
  {
    _id: '2',
    title: 'How Do You Upload Contacts into Cellcast?',
    description: 'Import your contact lists quickly and cleanly.',
    subTitle: 'Upload contacts into Cellcast',
    subDescription:
      'Import your customer database in seconds using a CSV file. Follow simple steps to clean, tag, and prepare your list for targeted communication.',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/7c57c92d60f541ddb7d9f079724ac4e5-5d2be40a62f44d8f.jpg',
    videoUrl:
      'https://www.loom.com/embed/7c57c92d60f541ddb7d9f079724ac4e5?sid=3951f344-523b-4fd4-a1ea-a5fb6414441e',
    isActive: true,
  },
  {
    _id: '3',
    title: 'How Do You Create a Campaign from Scratch?',
    description: 'Build and launch your first SMS or MMS campaign with ease.',
    subTitle: 'Create a campaign from scratch',
    subDescription:
      'Build powerful SMS or MMS campaigns from the ground up. Use templates, scheduling tools, and personalisation to maximise results.',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/75a604b3d4364de9bbb5895062c688b7-450d4ce45e3aabea.jpg',
    videoUrl:
      'https://www.loom.com/embed/75a604b3d4364de9bbb5895062c688b7?sid=93ec1c31-0dbf-4e6d-a32e-173397adf148',
    isActive: true,
  },

  {
    _id: '4',
    title: 'What Are the Different Ways You Can Send Messages?',
    description: 'Discover all the methods you can use to send messages effectively.',
    subTitle: 'Discover the different ways to send messages',
    subDescription:
      'Choose from four flexible sending methods to match your campaign goals. Learn when to use shared numbers, dedicated numbers, Alpha IDs, or your own mobile.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '5',
    title: 'How Do You Choose the Right Sending Method?',
    description: 'Select the best sending option based on your campaign goals.',
    subTitle: 'Choose the right sending method',
    subDescription:
      'Understand the benefits and limitations of each message-sending option. Pick the one that best aligns with your brand voice, compliance needs, and use case.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '6',
    title: 'How Do You Buy Credits and Set Up Auto Top-Up?',
    description: 'Top up your account and automate future credit purchases.',
    subTitle: 'Buy credits and set up auto top-up',
    subDescription:
      'Top up your account anytime and ensure campaigns never pause with auto-recharge. Learn how to manage payments and track spending easily.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '7',
    title: 'What Integrations and APIs Can You Use with Cellcast?',
    description: 'Connect your favourite tools and unlock powerful workflows.',
    subTitle: 'Integrate with Cellcast using APIs and platforms',
    subDescription:
      'Connect Cellcast to your CRM, eCommerce, or marketing tools like HubSpot. Explore how our powerful API enables automation and personalised messaging at scale.',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/a9d2af284c444949b9e61e95dbb8df1d-bf04958553f3095c.jpg',
    videoUrl:
      'https://www.loom.com/embed/a9d2af284c444949b9e61e95dbb8df1d?sid=169ebd01-a910-4527-b531-43c93e9dd9d8',
  },
  {
    _id: '8',
    title: 'How Do You Set Up Email to SMS?',
    description: 'Send SMS directly from your email with a simple setup.',
    subTitle: 'Set up Email to SMS',
    subDescription:
      'Send SMS directly from your email platform. Use your existing inbox to manage customer conversations with ease.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '9',
    title: 'What is the Difference Between a Segment and a Tag?',
    description: 'Group and organise your contacts for smarter targeting.',
    subTitle: 'Understand the difference between a segment and a tag',
    subDescription:
      'Segment contacts based on live data and behaviours. Use tags for static labels and better organisation of your lists.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '10',
    title: 'How Do You Use Your Dashboards?',
    description: 'Visualise your results and monitor performance in real-time.',
    subTitle: 'Use your dashboards effectively',
    subDescription:
      'Monitor campaign performance, engagement, and credit usage in real time. Access visual insights to drive smarter decisions.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '11',
    title: 'How Does the Single Inbox Work?',
    description: 'Manage all your messages in one unified communication hub.',
    subTitle: 'Manage conversations in the single inbox',
    subDescription:
      'View and reply to all incoming messages in one place. Track history, assign responses, and streamline customer support.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '12',
    title: 'What Is Safe Sending and Why Does It Matter?',
    description: 'Protect your campaigns with safeguards that prevent errors.',
    subTitle: 'Enable safe sending for peace of mind',
    subDescription:
      'Prevent duplicate sends, accidental broadcasts, and sensitive errors with built-in safeguards. Learn how to set rules that protect your brand.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '13',
    title: 'How Do You Track Links and Use Custom Domains?',
    description: 'Monitor click-throughs and brand your links for better trust.',
    subTitle: 'Track links and use custom domains',
    subDescription:
      'Shorten and brand your links to build trust and improve click-through rates. Monitor engagement in real time to optimise future sends.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '14',
    title: 'How Do You Set Up Automations?',
    description: 'Streamline your messaging with hands-free workflows.',
    subTitle: 'Set up automations that work for you',
    subDescription:
      'Trigger campaigns based on customer behaviour or time-based rules. Streamline workflows and save time while delivering timely messages.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '15',
    title: 'How Do You Add and Manage Users?',
    description: 'Control access and collaborate securely with your team.',
    subTitle: 'Add and manage users with the right access',
    subDescription:
      'Invite team members and control their permissions. Ensure secure collaboration with custom roles and audit trails.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
    isActive: true,
  },
  {
    _id: '16',
    title: 'What Is a Sub-Client and When Should You Use One?',
    description: 'Organise multiple brands or departments under one account.',
    subTitle: 'Use sub-clients to manage multiple brands or teams',
    subDescription:
      'Create separate environments for different stores, franchises, or departments. Keep data, campaigns, and reporting organised and distinct.',
    footerText: '',
    imagePath: '',
    videoUrl: '',
  },
  {
    _id: '17',
    title: 'How to Create Segments & Re-Targeting Campaigns (Ryan)',
    description:
      'Learn how to build customer segments and launch re-targeting campaigns effectively.',
    subTitle: '',
    subDescription: '',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/f130c31242c247629cd1d265f4c3a356-9c07b1d1c86291a4.jpg',
    videoUrl: 'https://www.loom.com/share/f130c31242c247629cd1d265f4c3a356',
    isActive: true,
  },
  {
    _id: '18',
    title: 'How to Purchase Credits',
    description: 'Easily buy credits to power your SMS and MMS campaigns.',
    subTitle: '',
    subDescription: '',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/7d6b05f0c2684fb9ada719c7e032d02b-db29ed0e7978decf.jpg',
    videoUrl: 'https://www.loom.com/share/7d6b05f0c2684fb9ada719c7e032d02b',
    isActive: true,
  },
  {
    _id: '19',
    title: 'How to use Lead Capture Form',
    description: 'Capture leads automatically with custom forms inside Cellcast.',
    subTitle: '',
    subDescription: '',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/ffab4fd3870142ca9e471f11616f33f5-966c2a38c15d0170.jpg',
    videoUrl: 'https://www.loom.com/share/ffab4fd3870142ca9e471f11616f33f5',
    isActive: true,
  },
  {
    _id: '20',
    title: 'How to Add Contacts',
    description: 'Add contacts manually or in bulk to start sending messages.',
    subTitle: '',
    subDescription: '',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/5d7ce497f7904033a24c12031da3d28f-64f3f41c5e9ee1a2.jpg',
    videoUrl: 'https://www.loom.com/share/5d7ce497f7904033a24c12031da3d28f',
    isActive: true,
  },
  {
    _id: '21',
    title: 'How to Purchase Dedicated Number',
    description: 'Learn how to purchase a dedicated number for your business messaging.',
    subTitle: '',
    subDescription: '',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/6a33f11099e14a68b0170b1452b0e779-773fc1e8f6f38b02.jpg',
    videoUrl: 'https://www.loom.com/share/6a33f11099e14a68b0170b1452b0e779',
    isActive: true,
  },
  {
    _id: '22',
    title: 'How to Register Sender ID & Custom Number',
    description: 'Register a sender ID or custom number to match your brand identity.',
    subTitle: '',
    subDescription: '',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/9a4e09df181f4f07bf20ca5db6ccce01-6470f0c86caa1726.jpg',
    videoUrl: 'https://www.loom.com/share/9a4e09df181f4f07bf20ca5db6ccce01',
    isActive: true,
  },
  {
    _id: '23',
    title: 'How to Create Short-Links',
    description: 'Create branded short links for your SMS campaigns to track engagement.',
    subTitle: '',
    subDescription: '',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/ceea16939a784d6aa00af36713bd05f1-5098b4f9463a9ea6.jpg',
    videoUrl: 'https://www.loom.com/share/ceea16939a784d6aa00af36713bd05f1',
    isActive: true,
  },
  {
    _id: '24',
    title: 'How to Setup a Low Credit Alert',
    description: 'Enable low credit alerts to avoid interruptions in your messaging campaigns.',
    subTitle: '',
    subDescription: '',
    footerText: '',
    imagePath:
      'https://cdn.loom.com/sessions/thumbnails/1932591ce91b46fc96196b41e2e3ed0b-be46bd27cc6dacfb.jpg',
    videoUrl: 'https://www.loom.com/share/1932591ce91b46fc96196b41e2e3ed0b',
    isActive: true,
  },
]

export interface UseHowToVideosParams {
  initialSearch?: string
  pageSize?: number
  category?: string
  isActive?: boolean
}

export interface Video {
  id: string
  title: string
  description: string
  videoUrl: string
  thumbnailUrl: string
  category: string
  article: string
  duration: string
  publishedAt: string
}

interface UseHowToVideosReturn {
  videos: HowToVideo[]
  isLoading: boolean
  error: any
  searchTerm: string
  setSearchTerm: (term: string) => void
  totalVideos: number
  currentPage: number
  setCurrentPage: (page: number) => void
  totalPages: number
  refetch: () => void
}

export const useHowToVideos = ({
  initialSearch = '',
  pageSize = 20,
  category = '',
  isActive,
}: UseHowToVideosParams = {}): UseHowToVideosReturn => {
  const [searchTerm, setSearchTerm] = useState(initialSearch)
  const [currentPage, setCurrentPage] = useState(1)
  const [videos, setVideos] = useState<HowToVideo[]>([])
  const [totalVideos, setTotalVideos] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const [getHowToVideos, {isLoading, error}] = useLazyGetHowToVideosQuery()

  const debouncedSearchTerm = useDebounce(searchTerm, 500)

  const fetchVideos = async () => {
    try {
      const result = await getHowToVideos({
        search: debouncedSearchTerm || '',
        page: currentPage,
        size: pageSize,
        category: category || undefined,
        isActive: isActive !== undefined ? isActive : true,
      })

      if (result.data?.status && result.data?.data) {
        const {items: apiVideos, total, totalPages: apiTotalPages} = result.data.data
        setVideos(apiVideos)
        setTotalVideos(total)
        setTotalPages(apiTotalPages)
      }
    } catch (err) {}
  }

  // Reset to first page when filters change (but not when currentPage changes)
  useEffect(() => {
    setCurrentPage(1)
  }, [debouncedSearchTerm, category, isActive, pageSize])

  // Fetch videos when page or filters change
  useEffect(() => {
    fetchVideos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, category, isActive, currentPage, pageSize])

  return {
    videos,
    isLoading,
    error,
    searchTerm,
    setSearchTerm,
    totalVideos,
    currentPage,
    setCurrentPage,
    totalPages,
    refetch: fetchVideos,
  }
}

export const useHowToVideosAdmin = ({
  initialSearch = '',
  pageSize = 20,
  category = '',
  isActive,
}: UseHowToVideosParams = {}): UseHowToVideosReturn => {
  const [searchTerm, setSearchTerm] = useState(initialSearch)
  const [currentPage, setCurrentPage] = useState(1)
  const [videos, setVideos] = useState<HowToVideo[]>([])
  const [totalVideos, setTotalVideos] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const [getHowToVideos, {isLoading, error}] = useLazyGetHowToVideosAdminQuery()

  const debouncedSearchTerm = useDebounce(searchTerm, 500)

  const fetchVideos = async () => {
    try {
      const result = await getHowToVideos({
        search: debouncedSearchTerm || '',
        page: currentPage,
        size: pageSize,
        category: category || undefined,
        isActive: isActive !== undefined ? isActive : undefined,
      })

      if (result.data?.status && result.data?.data) {
        const {items: apiVideos, total, totalPages: apiTotalPages} = result.data.data
        setVideos(apiVideos)
        setTotalVideos(total)
        setTotalPages(apiTotalPages)
      } else {
        // Fallback to filtered hardcoded data
        const searchTerm = debouncedSearchTerm || ''
        const filtered = fallbackVideos.filter((video) => {
          const matchesSearch =
            !searchTerm ||
            video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (video.description &&
              video.description.toLowerCase().includes(searchTerm.toLowerCase()))

          const matchesCategory = !category || video.category === category
          const matchesStatus = isActive === undefined || video.isActive === isActive

          return matchesSearch && matchesCategory && matchesStatus
        })
        // Apply pagination to filtered results
        const startIndex = (currentPage - 1) * pageSize
        const paginatedVideos = filtered.slice(startIndex, startIndex + pageSize)

        setVideos(paginatedVideos)
        setTotalVideos(filtered.length)
        setTotalPages(Math.ceil(filtered.length / pageSize))
      }
    } catch (err) {
      console.warn('API call failed, using fallback data:', err)
      // Fallback to filtered hardcoded data with proper filtering
      const searchTerm = debouncedSearchTerm || ''
      const filtered = fallbackVideos.filter((video) => {
        const matchesSearch =
          !searchTerm ||
          video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (video.description && video.description.toLowerCase().includes(searchTerm.toLowerCase()))

        const matchesCategory = !category || video.category === category
        const matchesStatus = isActive === undefined || video.isActive === isActive

        return matchesSearch && matchesCategory && matchesStatus
      })

      // Apply pagination to filtered results
      const startIndex = (currentPage - 1) * pageSize
      const paginatedVideos = filtered.slice(startIndex, startIndex + pageSize)

      setVideos(paginatedVideos)
      setTotalVideos(filtered.length)
      setTotalPages(Math.ceil(filtered.length / pageSize))
    }
  }

  // Reset to first page when filters change (but not when currentPage changes)
  useEffect(() => {
    setCurrentPage(1)
  }, [debouncedSearchTerm, category, isActive, pageSize])

  // Fetch videos when page or filters change
  useEffect(() => {
    fetchVideos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, category, isActive, currentPage, pageSize])

  return {
    videos,
    isLoading,
    error,
    searchTerm,
    setSearchTerm,
    totalVideos,
    currentPage,
    setCurrentPage,
    totalPages,
    refetch: fetchVideos,
  }
}

// Hook for fetching video by feature
export const useHowToVideoByFeature = (feature: string) => {
  const [video, setVideo] = useState<HowToVideo | null>(null)
  const [getVideoByFeature, {isLoading, error}] = useLazyGetHowToVideosByFeatureQuery()

  const fetchVideoByFeature = async () => {
    if (!feature) return

    try {
      const result = await getVideoByFeature({feature})

      if (result.data?.status && result.data?.data && result.data.data.length > 0) {
        // Return the first video from the array
        setVideo(result.data.data[0])
      } else {
        setVideo(null)
      }
    } catch (err) {
      console.error('Failed to fetch video by feature:', err)
      setVideo(null)
    }
  }

  useEffect(() => {
    fetchVideoByFeature()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feature])

  return {
    video,
    isLoading,
    error,
    refetch: fetchVideoByFeature,
  }
}
